import { Controller } from "@hotwired/stimulus"

// Samodzielny widget formularza raportu: kaskada moduł -> raport (zmiana modułu przebudowuje listę
// raportów), a wybór raportu wypełnia ukryte pola techniczne (code, fields, use_entity) i podstawia
// opis z katalogu. Pola techniczne są schowane pod wspólnym "więcej opcji".
// Connects to data-controller="report-metric"
export default class extends Controller {
  static targets = ["code", "fields", "useEntity", "description", "reportSelect", "selectedField", "variableButton"]
  // { "mail": [{ code, name, key, use_entity, description }], ... } - dostępne raporty per moduł
  static values = { metrics: Object }

  // wybór modułu (rodziny) - przebudowuje listę raportów dla tego modułu
  familyChanged(event) {
    const list = this.metricsValue[event.target.value] || []
    const select = this.reportSelectTarget

    select.length = 1 // zostaje tylko placeholder (pierwszy option)
    list.forEach((m) => {
      const opt = new Option(m.name, m.code)
      opt.dataset.key = m.key
      opt.dataset.useEntity = m.use_entity
      opt.dataset.description = m.description || ""
      select.add(opt)
    })
    select.selectedIndex = 0
    select.disabled = list.length === 0
    // raport wrócił do placeholdera - wyzeruj też auto-podstawiony opis (własnego tekstu usera nie ruszamy)
    if (this.hasDescriptionTarget && (this.descriptionTarget.value.trim() === "" || this.descriptionTarget.value === this.autoDescription)) {
      this.descriptionTarget.value = ""
      this.autoDescription = ""
    }
    // brak wybranego raportu - pola techniczne znów edytowalne (ścieżka ręczna)
    this.lockTechnical(false)
  }

  // wybór raportu - wypełnia ukryte pola techniczne + podstawia opis
  reportChanged(event) {
    const option = event.target.selectedOptions[0]
    if (!option || !option.value) {
      this.lockTechnical(false)
      return
    }

    this.codeTarget.value = option.value
    this.fieldsTarget.value = option.dataset.key
    if (this.hasUseEntityTarget) this.useEntityTarget.checked = option.dataset.useEntity === "true"
    // opis aktualizujemy przy KAŻDEJ zmianie raportu, ale nie kasujemy własnego tekstu usera -
    // podmieniamy tylko gdy pole jest puste albo wciąż trzyma wcześniej podstawiony opis
    if (this.hasDescriptionTarget) {
      const desc = this.descriptionTarget
      if (desc.value.trim() === "" || desc.value === this.autoDescription) {
        desc.value = option.dataset.description || ""
        this.autoDescription = desc.value
      }
    }
    // konkretny raport wybrany - katalog narzuca pola techniczne, blokujemy je do edycji
    this.lockTechnical(true)
  }

  // blokuje/odblokowuje pola techniczne (katalog je narzuca po wyborze raportu). code/fields = readonly,
  // bo disabled nie wysyłałby ich wartości; pomocnicy = disabled; use_entity synchronizuje ukryte pole
  // Rails (disabled checkbox się nie wysyła, więc value trzyma hidden input).
  lockTechnical(locked) {
    const grey = (el) => {
      el.classList.toggle("bg-gray-100", locked)
      el.classList.toggle("cursor-not-allowed", locked)
    }
    if (this.hasCodeTarget) { this.codeTarget.readOnly = locked; grey(this.codeTarget) }
    if (this.hasFieldsTarget) { this.fieldsTarget.readOnly = locked; grey(this.fieldsTarget) }
    if (this.hasSelectedFieldTarget) this.selectedFieldTarget.disabled = locked
    if (this.hasVariableButtonTarget) this.variableButtonTarget.disabled = locked
    if (this.hasUseEntityTarget) {
      this.useEntityTarget.disabled = locked
      const hidden = this.useEntityTarget.previousElementSibling
      if (hidden && hidden.type === "hidden") hidden.value = locked && this.useEntityTarget.checked ? "1" : "0"
    }
  }

  // "Dodaj kolumnę" - dokleja kod wybranego pola jako nową linię listy fields
  appendField() {
    const value = this.selectedFieldTarget.value
    if (!value) return

    this.fieldsTarget.value += `\n${value}`
  }

  // "Dodaj zmienną" - dokleja szablon zmiennej (zm1 = {kod pola}) do listy fields
  addVariable() {
    const value = this.selectedFieldTarget.value
    if (!value) return

    this.fieldsTarget.value += `\nzm1 = {${value}}`
  }
}
